export default "__VITE_ASSET__CAm78rtC__"